import { Userdata } from "./Userdata";

export class User {
    constructor(user?: User) {
        Object.assign(this, user);
    }

    public auth: boolean = false;
    public token: string = "";
    public userdata?: Userdata | undefined = undefined;
}